import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid crm_dashboard" }
const _hoisted_2 = { class: "row widget-grid" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCrm',
  setup(__props) {

const transactionHistory = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/transactionHistory.vue"))
const topCustomer = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/topCustomer.vue"))
const allNotification = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/allNotification.vue"))
const balanceOverview = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/balanceOverview.vue"))
const salesAnalyics = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/salesAnalyics.vue"))
const dealOpen = defineAsyncComponent(() => import("@/components/theme/dashboards/crm/dealOpen.vue"))

return (_ctx: any,_cache: any) => {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumbs, {
        main: "Dashboard",
        titles: "CRM Dashboard",
        title: "CRM Dashboard"
      }),
      _createVNode(_unref(transactionHistory)),
      _createVNode(_unref(topCustomer)),
      _createVNode(_unref(allNotification)),
      _createVNode(_unref(balanceOverview)),
      _createVNode(_unref(salesAnalyics)),
      _createVNode(_unref(dealOpen))
    ])
  ]))
}
}

})